<template lang="html">
  <div>
    <v-container justify-center wrap fluid class="contact-container">
      <v-layout justify-center wrap>
        <v-flex xs12 sm8 md8 lg6>
          <h1 class="contact-title">Contact Us</h1>

          <v-flex mt-4>
            <p class="body-text">We appreciate your interest in Blitzoo.</p>
          </v-flex>

          <v-flex mt-4 align-center justify-center row class="contact-email">
            <!-- <v-icon x-large class="orange--text text--lighten-2">email</v-icon> -->
            <img src="../assets/Icon_Mail.svg" height="26px" />
            <h3 class="contact-subtitle">Careers:</h3>
            <a href="mailto:careers@blitzoo.com" target="_top" class="email-style" style="margin-left: 1rem;">careers@blitzoo.com</a>
          </v-flex>

          <v-flex mt-4 align-center justify-center row class="contact-email">
            <!-- <v-icon x-large class="orange--text text--lighten-2">email</v-icon> -->
            <img src="../assets/Icon_Mail.svg" height="26px" />
            <h3 class="contact-subtitle">Business Inquiries:</h3>
            <a href="mailto:contact@blitzoo.com" target="_top" class="email-style" style="margin-left: 1rem;">contact@blitzoo.com</a>
          </v-flex>

          <v-flex mt-4 align-center justify-center row class="contact-email">
            <img src="../assets/Icon_Mail.svg" height="26px" />
            <h3 class="contact-subtitle">Casino App Support Inquiries:</h3>
            <a href="mailto:support@blitzoo.com" target="_top" class="email-style" style="margin-left: 1rem;">support@blitzoo.com</a>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>

    <v-layout
      column
      wrap
      mt-4
      align-center
      xs10 offset-xs1
    >
      <v-flex xs12>
        <v-container grid-list-xs id="locationContainer">
          <v-layout row wrap align-start justify-center class="ieLayout">
            <v-flex xs12 sm6 md4 class="ieFlex">
              <v-card class="elevation-0 transparent">
                <img
                  :src="minnetonka"
                  class="imgWidth"
                  style="border-radius: 1rem; width: 90%;">
                <v-card-title primary-title class="layout justify-center" style="padding-bottom: 0;">
                  <div class="headline text-xs-center description-section body-title" style=""><span class="body-title">Minneapolis, MN</span></div>
                </v-card-title>
              </v-card>
            </v-flex>
            <v-flex xs12 sm6 md4 class="ieFlex">
              <v-card class="elevation-0 transparent">
                <img
                  :src="vancouver"
                  class="imgWidth"
                  style="border-radius: 1rem; width: 90%;">
                <v-card-title primary-title class="layout justify-center" style="padding-bottom: 0;">
                  <div class="headline description-section body-title"><span class="body-title">Vancouver, BC</span></div>
                </v-card-title>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  data () {
    return {
      vancouver: require('../assets/Location_Vancouver.png'),
      minnetonka: require('../assets/Location_Minnetonka.png'),
      footerHeight: 0,
      originalFooter: 0
    }
  },
  mounted () {
    if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
      Array.from(document.querySelectorAll('.ieFlex')).forEach(function (el) {
        let docFrag = document.createDocumentFragment()
        while (el.firstChild) {
          let child = el.removeChild(el.firstChild)
          docFrag.appendChild(child)
        }

        // replace el with document fragment
        el.parentNode.replaceChild(docFrag, el)
      })

      this.footerHeight = parseInt(getComputedStyle(document.querySelector('#locationContainer')).height) + 30

      this.originalFooter = parseInt(getComputedStyle(document.querySelector('#footer')).height)
      document.querySelector('#footer').style.height = this.footerHeight + 'px'
    }

    // resizing UI; commented out for now to push 2 new jobs
    // let currentWidth = window.innerWidth
    // let currentHeight = window.innerHeight
    //
    // if (currentWidth < 830 && currentWidth >= 800) {
    //   Array.from(document.querySelectorAll('.imgWidth')).forEach(function (el) {
    //     el.style.width = '80%'
    //   })
    // } else if (currentWidth < 800 && currentWidth >= 780) {
    //   Array.from(document.querySelectorAll('.imgWidth')).forEach(function (el) {
    //     el.style.width = '70%'
    //   })
    // } else if (currentWidth < 780) {
    //   Array.from(document.querySelectorAll('.imgWidth')).forEach(function (el) {
    //     el.style.width = '60%'
    //   })
    // }
    //
    // window.onresize = function () {
    //   currentWidth = window.innerWidth
    //   currentHeight = window.innerHeight
    //   console.log('Width: ' + currentWidth)
    //   console.log('Height: ' + currentHeight)
    //   console.log(`Window Width: ${document.documentElement.clientWidth}`)
    //   console.log('===')
    //
    //   if (currentWidth < 830 && currentWidth >= 800) {
    //     Array.from(document.querySelectorAll('.imgWidth')).forEach(function (el) {
    //       el.style.width = '80%'
    //     })
    //   } else if (currentWidth < 800 && currentWidth >= 780) {
    //     Array.from(document.querySelectorAll('.imgWidth')).forEach(function (el) {
    //       el.style.width = '70%'
    //     })
    //   } else if (currentWidth < 780) {
    //     Array.from(document.querySelectorAll('.imgWidth')).forEach(function (el) {
    //       el.style.width = '60%'
    //     })
    //   }
    // }
  },
  destroyed () {
    document.querySelector('#footer').style.height = this.originalFooter + 'px'
  }
}
</script>

<style lang="scss" scoped>
// #contact-container {
//   display: grid;
//   place-self: center;
// }
//
// #content {
//   color: white;
//   text-align: left;
//   width: 55vw;
//   height: 50vh;
// }
.contact-container {
  background-image: url('../assets/Header_Contact.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.contact-title {
  font-family: 'open-sans-extrabold', serif;
  font-weight: 700;
  font-size: 45px;
  color: #ffffff;
  letter-spacing: -1px;
}

.contact-subtitle {
  font-family: 'open-sans-extrabold', serif;
  font-style: normal;
  font-weight: 800;
  font-size: 18px;
  color: #ffffff;
  margin-left: 0.5rem;
}

.contact-email {
  display: flex;
}

.body-title {
  font-family: 'open-sans-semibold', serif;
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  color: #6e01ff;
}

.body-text {
  font-size: 18px;
  color: #ffffff;
}

.email-style {
  font-family: 'open-sans-semibold', serif;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #ffffff;
  text-decoration: none;
}

.description-body {
  padding-top: 0;
}

.contact-text-container {
  display: grid;
  justify-content: center;
}

#outer-container {
  display: grid;
  justify-content: center;
}

#wrap-container {
  // color: white;
  text-align: left;
  width: 70vw;
}

#title {
  margin-bottom: 2rem;
}

#content-grid {
  display: grid;
  // grid-template-columns: 1fr 1fr 1fr;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(3, 1fr);
}
</style>
